import { render, staticRenderFns } from "./indexView.vue?vue&type=template&id=6e88cda3&scoped=true"
import script from "./indexView.vue?vue&type=script&lang=js"
export * from "./indexView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e88cda3",
  null
  
)

export default component.exports